import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation } from '@tanstack/vue-query'

export const useSendForm = () => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      if (data.id) {
        return http.put(`/inventory/tabs/${data.id}`, data)
      } else {
        return http.post(`/inventory/tabs`, data)
      }
    },
  })

  const sendForm = async (data: any, valid: boolean, showMessage: boolean = true) => {
    if (!valid) return

    try {
      await mutation.mutateAsync(data)

      if (showMessage) addSuccess(trs('itf.saved'))
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    sendForm,
  }
}
